// Pure math utilities — no DOM or canvas dependencies.

export function lerp(start: number, end: number, amount: number): number {
  return start + (end - start) * amount;
}

export function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value));
}

export function easeInOut(value: number): number {
  const clamped = clamp01(value);
  return clamped < 0.5
    ? 4 * clamped * clamped * clamped
    : 1 - Math.pow(-2 * clamped + 2, 3) / 2;
}

export function snapToPixel(value: number): number {
  return Math.round(value / 2) * 2;
}

export function phaseAmount(progress: number, start: number, end: number): number {
  if (end <= start) {
    return progress >= end ? 1 : 0;
  }
  return clamp01((progress - start) / (end - start));
}

export function clampRange(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function averageNumbers(values: number[], fallback: number = 72): number {
  const valid = values.filter((value) => Number.isFinite(value));
  return valid.length > 0 ? valid.reduce((a, b) => a + b, 0) / valid.length : fallback;
}

export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
